{
  "filters": {
    "clear": "Limpiar",
    "filters": "Filtros",
    "filter_input": "Filtrar...",
    "not_found": "No se encontraron filtros",
    "tooltip": "Abrir Filtros",
    "alerts": {
      "title": "Alertas"
    },
    "states": {
      "title": "Nodos",
      "all": "Nodos totales",
      "activated": "Activado",
      "deactivated": "Desactivado",
      "hibernated": "Hibernando",
      "idle": "Inactivo",
      "active": "Activo",
      "resolved": "Resuelto",
      "online": "Informar",
      "offline": "No informar",
      "leased": "Rentado",
      "shared": "Compartido"
    },
    "thiamis-debug-tag": {
      "title": "Etiquetas"
    },
    "tags": {
      "title": "Etiquetas",
      "membership": "Membresía",
      "formation_request": "Nueva solicitud de la organización",
      "partnership": "Asociación",
      "alert": "Alerta",
      "message": "Mensaje"
    },
    "status": {
      "title": "Estado"
    },
    "channels": {
      "title": "Canales"
    },
    "thiamis": {
      "title": "Thiamis"
    },
    "device": {
      "title": "Dispositivos"
    },
    "devices": {
      "title": "Dispositivos"
    },
    "sensors": {
      "title": "Sensores"
    },
    "partners": {
      "title": "Asociados"
    },
    "org": {
      "title": "Asociados"
    },
    "archive": {
      "type": {
        "title": "Tipo de archivos"
      },
      "tag": {
        "title": "Etiquetas"
      }
    },
    "user_file": {
      "type": {
        "title": "Tipo de archivos"
      },
      "tag": {
        "title": "Etiquetas"
      }
    },
    "message": {
      "type": {
        "title": "Tipo de mensajes",
        "all": "Mensajes totales",
        "alerts": "Alertas",
        "notifications": "Notificaciones"
      }
    },
    "filter-groups": {
      "partnership-organization": "Organización",
      "api-permission": "Permisos",
      "org-partnerships": "Asociaciones",
      "user-role": "Rol",
      "last-login": "Último acceso",
      "user-organization": "Organización",
      "device-status": "Estado",
      "alert-status": "Estado",
      "firmware-status": "Estado",
      "firmware-thiamis": "Dispositivo",
      "device-type": "Dispositivo",
      "calibration-status": "Estado",
      "calibration-sensor": "Sensor",
      "calibration-ready": "Listo",
      "sensors": "Sensores",
      "tags": "Etiquetas",
      "report-type": "Tipo",
      "reporting-period": "Período del informe",
      "widget-type": "Widget"
    },
    "filter-tags": {
      "org-partnerships": {
        "with-partners": "Con socios",
        "no-partners": "Sin socios"
      },
      "user-role": {
        "owner": "Propietario",
        "manager": "Administrador",
        "user": "Usuario",
        "admin": "Administrador del sistema",
        "partner": "Socio",
        "support": "Soporte"
      },
      "last-login": {
        "last-7-days": "Últimos 7 días",
        "last-30-days": "Últimos 30 días",
        "over-90-days": "Hace más de 90 días",
        "never": "Nunca"
      },
      "alert-status": {
        "activated": "Activado",
        "deactivated": "Desactivado",
        "active": "Activo",
        "resolved": "Resuelto",
        "idle": "Inactivo"
      },
      "device-status": {
        "activated": "Activado",
        "deactivated": "Desactivado",
        "hibernated": "Hibernando",
        "offline": "No informar",
        "online": "Informar",
        "good": "Bueno",
        "moderate": "Moderado",
        "poor": "Pobre",
        "shared": "Compartido",
        "leased": "Rentado"
      },
      "firmware-status": {
        "removed": "Eliminado",
        "available": "Disponible"
      },
      "device-type": {
        "airthinx": "Aethair IAQ",
        "airthinxpro": "Aethair Pro",
        "airthinx2": "Aethair IAQ 2",
        "driq": "Driq",
        "healthway": "Purificador",
        "inventory": "Inventario",
        "thiamis-1000": "Thiamis-1000",
        "thiamis-x": "Thiamis-X"
      },
      "calibration-status": {
        "ok": "Aprobado",
        "not_run": "No ejecutado",
        "fail": "Fallido"
      },
      "calibration-ready": {
        "yes": "Sí",
        "no": "No"
      },
      "report-type": {
        "air_quality": "Calidad del Aire",
        "aethair_cms_2567": "Aethair CMS-2567",
        "perimeter_monitor": "Monitoreo Perimetral"
      },
      "widget-type": {
        "chart_widget": "Gráfico",
        "chart_table_widget": "Tabla de Gráfico",
        "node_widget": "Dispositivo",
        "heatmap_widget": "Parámetro",
        "distribution_widget": "Distribución",
        "map_widget": "Mapa",
        "blocks_widget": "Bloque"
      }
    }
  },
  "mentions": {
    "hint": "Puedes añadir etiquetas usando @",
    "create": "Crear"
  }
}
